<template>
    <div class="dodel-cart-header">
        <div class="cart-header-title">
            {{translate('Nutrition Calculator')}}
        </div>
        <div class="cart-header-info">
            <div>{{translate('%DV = % Daily Value')}}</div>
        </div>
        <div class="cart-header-columns">
            <div class="calories cart-header-column">
                <div class="number">
                    {{total_calories}} {{translate('Cals')}}
                </div>
                <div class="description">
                    {{translate('Calories')}}
                </div>
            </div>
            <div class="fat cart-header-column">
                <div class="number">
                    {{total_fat}} {{translate('g')}}
                </div>
                <div class="description">
                    {{translate('Fat')}} ({{fat_dv}}% {{translate('DV')}}*)
                </div>
            </div>
            <div class="carbohydrates cart-header-column">
                <div class="number">
                    {{total_carbohydrates}} {{translate('g')}}
                </div>
                <div class="description">
                    {{translate('Carbohydrates')}} ({{carbohydrates_dv}}% {{translate('DV')}}*)
                </div>
            </div>
            <div class="protein cart-header-column">
                <div class="number">
                    {{total_protein}} {{translate('g')}}
                </div>
                <div class="description">
                    {{translate('Protein')}}
                </div>
            </div>
            <div class="sodium cart-header-column">
                <div class="number">
                    {{total_sodium}} {{translate('mg')}}
                </div>
                <div class="description">
                    {{translate('Sodium')}} ({{sodium_dv}}% {{translate('DV')}}*)
                </div>
            </div>
        </div>
        <div style="text-align:center;font-size:12px;line-height:1;color:#000000;">
            <p>Learn how to use % Daily Value at Health Canada</p>

            <p>Percent Daily Values (DV) are based on a 2,000 calorie diet. Your daily values may be higher or lower depending on your calorie needs.</p>

            <p>We provide known instances of allergens; however, cross contamination is possible due to common handling and preparation areas in our restaurants. We are unable to guarantee that any menu item can be completely free of allergens. Customers with allergies and sensitivities should exercise judgment when ordering. Accordingly, please note that no products are certified as vegetarian or vegan.</p>
        </div>
        <div class="cart-header-details" v-if="is_cart">
            <div class="column">
                <div class="line">
                    <div class="description">
                        {{translate('Serving Size')}}:
                    </div>
                    <div class="number">
                        {{serving_size}} {{translate('g')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Calories')}}:
                    </div>
                    <div class="number">
                        {{total_calories}} {{translate('Cals')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Fat')}}:
                    </div>
                    <div class="number">
                        {{total_fat}} {{translate('g')}} ({{fat_dv}}% {{translate('DV')}}*)
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Saturated Fat')}}:
                    </div>
                    <div class="number">
                        {{saturated_fat}} {{translate('g')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Trans Fat')}}:
                    </div>
                    <div class="number">
                        {{trans_fat}} {{translate('g')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Saturated & Trans Fat')}}:
                    </div>
                    <div class="number">
                        ({{saturated_fat_dv}}% {{translate('DV')}}*)
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="line">
                    <div class="description">
                        {{translate('Cholesterol')}}:
                    </div>
                    <div class="number">
                        {{cholesterol}} {{translate('mg')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Sodium')}}:
                    </div>
                    <div class="number">
                        {{total_sodium}} {{translate('mg')}} ({{sodium_dv}}% {{translate('DV')}}*)
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Carbohydrates')}}:
                    </div>
                    <div class="number">
                        {{total_carbohydrates}} {{translate('g')}} ({{carbohydrates_dv}}% {{translate('DV')}}*)
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Fibre')}}:
                    </div>
                    <div class="number">
                        {{fibre}} {{translate('g')}} ({{fibre_dv}}% {{translate('DV')}}*)
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Sugar')}}:
                    </div>
                    <div class="number">
                        {{sugar}} {{translate('g')}}
                    </div>
                </div>
                <div class="line">
                    <div class="description">
                        {{translate('Protein')}}:
                    </div>
                    <div class="number">
                        {{protein}} {{translate('g')}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cart-header',
    data(){
        return {
            dv: {
                fat: 65,
                saturated_fat: 20,
                cholesterol: 300,
                sodium: 2400,
                carbohydrate: 300,
                fibre: 25,
            }
        }
    },
    methods: {
        translate(string){
            return this.$store.state.language[string]
        },
        calculate(data){
            let value = 0
            this.$store.state.cart.forEach(cart_item=>{
                if(cart_item.include===true)
                    cart_item.nutritions.forEach(nutrition => {
                        if(nutrition.include===true)
                            value+=parseFloat(nutrition[data])
                    })
            })
            return parseFloat(value.toFixed(2))
        }
    },
    computed: {
        is_cart(){
            return this.$route.name=='cart'
        },
        serving_size(){
            return this.calculate('total_serving')
        },
        total_calories(){
            return this.calculate('calories')
        },
        total_fat(){
            return this.calculate('total_fat')
        },
        total_carbohydrates(){
            return this.calculate('carbohydrates')
        },
        total_protein(){
            return this.calculate('protein')
        },
        saturated_fat(){
            return this.calculate('saturated_fat')
        },
        total_sodium(){
            return this.calculate('sodium')
        },
        trans_fat(){
            return this.calculate('trans_tat')
        },
        cholesterol(){
            return this.calculate('cholesterol')
        },
        fibre(){
            return this.calculate('fiber')
        },
        sugar(){
            return this.calculate('sugars')
        },
        protein(){
            return this.calculate('protein')
        },
        fat_dv(){
            return Math.round(this.total_fat/this.dv.fat*100)
        },
        carbohydrates_dv(){
            return Math.round(this.total_carbohydrates/this.dv.carbohydrate*100)
        },
        sodium_dv(){
            return Math.round(this.total_sodium/this.dv.sodium*100)
        },
        fibre_dv(){
            return Math.round(this.fibre/this.dv.fibre*100)
        },
        saturated_fat_dv(){
            return Math.round((this.saturated_fat + this.trans_fat)/this.dv.saturated_fat*100)
        }
    }
}
</script>

<style>
    .dodel-cart-header .cart-header-title{
        font-size: 36px;
        text-align: center;
        font-weight: bold;
    }
    .dodel-cart-header .cart-header-info{
        text-align: center;
        margin: 20px auto;
    }
    .dodel-cart-header .cart-header-columns{
        display: flex;
        justify-content: center;
    }
    .dodel-cart-header .cart-header-columns .cart-header-column{
        flex-basis: 20%;
        box-sizing: border-box;
        padding: 15px;
        text-align: center;
    }
    .dodel-cart-header .cart-header-columns .cart-header-column .number{
        font-size: 36px;
    }
    .cart-header-details{
        display: flex;
        justify-content: space-between;
    }
    .cart-header-details .column{
        flex-basis: 48%;

    }
    .cart-header-details .column .line{
        border-bottom: 1px dashed rgba(0,0,0,.3);
        display: flex;
        color: rgba(0,0,0,.7);
        justify-content: space-between;
        padding: 10px 0;
    }
    .cart-header-details .column .line .number{
        font-weight: bold;
        color: rgba(0,0,0,1);
    }

    @media screen and (max-width: 768px){
        .dodel-cart-header .cart-header-columns, .cart-header-details{
            display: block;
        }
    }
</style>